module.exports = __webpack_public_path__ + "img/shop_front_4.26c110cc.jpg";